export class SearchUtil {

    public static hasMatch(haystack: string, needle: string): boolean {
        return SearchUtil.normalize(haystack).includes(SearchUtil.normalize(needle));
    }

    public static normalize(searchString: string): string {
        return searchString
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

}
